import styled from "styled-components"
import React from "react"

import { Box, FlexRow, FlexColumn } from "components/box"
import { Link as _Link } from "components/text/links"
import { ParagraphLarge, Eyebrow } from "components/text"
import Icon from "components/icon"
import { baseRoutes } from "routes"

const Container = styled(FlexRow)`
  position: relative;

  background-color: ${props => props.theme.colors.melrose};
  border-radius: ${props => props.theme.space[2]};

  cursor: pointer;
  overflow: hidden;
`

const ContentContainer = styled(FlexColumn)`
  justify-content: center;
  align-items: flex-start;
  flex: 1;
`

const Link = styled(_Link)`
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 100%;
`

const LeafIconContainer = styled(Box)`
  position: absolute;
  left: -30px;
  bottom: -20%;

  svg {
    height: 80px;
    width: auto;
    opacity: 0.06;
  }

  @media (min-width: ${props => props.theme.breakpoints.sm}px) {
    left: -25px;

    svg {
      height: 116px;
    }
  }
`

export const UpdateTreatmentBanner = () => (
  <Container my={5}>
    <Link to={baseRoutes.addTreatment()} p={[3, 3, 5, 5]}>
      <LeafIconContainer>
        <Icon name="supplement" />
      </LeafIconContainer>
      <ContentContainer ml={[6, 6, 8, 8]}>
        <Box px={4} bg="sandy">
          <Eyebrow>NEW</Eyebrow>
        </Box>
        <ParagraphLarge bold>Shop our Supplements</ParagraphLarge>
      </ContentContainer>
      <Icon name="arrowRight" />
    </Link>
  </Container>
)
